/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { DynaForm, UISchema, UISchemaScope } from '../../dynaForm';

const EXAMPLE_SCHEMA = JSON.stringify(
  {
    properties: {
      exampleFieldset: {
        component: 'Fieldset',
        translation: {
          title: {
            de: 'Beispiel',
            en: 'Example',
          },
        },
        children: {
          exampleTextField: {
            component: 'TextField',
            scopes: ['admin', 'project'],
            translation: {
              title: {
                de: 'Beispiel Textfeld',
                en: 'Example Text Field',
              },
            },
          },
        },
      },
    },
  },
  null,
  2,
);

export default function DynaFormPreview() {
  const [uiSchemaInput, setUISchemaInput] = useState<string>(EXAMPLE_SCHEMA);
  const [selectedScope, setSelectedScope] = useState<UISchemaScope>(
    UISchemaScope.PROJECT,
  );
  const [uiSchema, setUiSchema] = useState<UISchema | null>(null);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    setError(null);
    try {
      const parsedSchema = JSON.parse(uiSchemaInput);
      setUiSchema(parsedSchema);
    } catch (e) {
      setUiSchema(null);
      setError(e);
    }
  }, [uiSchemaInput]);

  return (
    <>
      <Typography variant="h4" sx={{ marginBottom: '32px' }}>
        Live Preview for DynaForm UI Schema
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: 'auto',
          gap: '16px',
        }}
      >
        <Box sx={{ minHeight: '60dvh' }}>
          <ToggleButtonGroup
            color="primary"
            size="small"
            value={selectedScope}
            exclusive
            onChange={(_, scope) => {
              setSelectedScope(scope);
            }}
            aria-label="Scope"
            sx={{ marginBottom: '16px' }}
          >
            <ToggleButton value="device">device</ToggleButton>
            <ToggleButton value="shop">shop</ToggleButton>
            <ToggleButton value="project">project</ToggleButton>
            <ToggleButton value="admin">admin</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            id="outlined-multiline-flexible"
            label="Poral UI Schema"
            multiline
            minRows={32}
            sx={{ width: '100%' }}
            value={uiSchemaInput}
            onChange={(e) => setUISchemaInput(e.target.value)}
          />
        </Box>
        <Box>
          {uiSchema ? (
            <DynaForm
              uiSchema={uiSchema}
              currentScope={selectedScope}
              isPreview
              onSubmit={() => {}}
            />
          ) : error ? (
            <Alert severity="error">
              <Typography variant="h6">JSON Error</Typography>
              {error.message}
            </Alert>
          ) : (
            <Alert severity="info">No JSON provided yet.</Alert>
          )}
        </Box>
      </Box>
    </>
  );
}
